// Member-management write calls (SOW §3.5). The published api-client doesn't yet expose
// CommandClient.changeMemberTier/Status/editMember (that lands with the next batched SDK release),
// so until then we POST the endpoints directly — same auth contract as HttpClient.request (bearer
// token + credentials, PHI-safe error envelope). Swap to the SDK methods once the version bump ships.
import { API_ORIGIN } from "../config";

export type Tier = "basic" | "premium" | "fighter";
export type MemberStatus = "active" | "paused" | "cancelled";
export interface MemberEditFields {
  first_name?: string;
  last_name?: string;
  phone?: string;
  email?: string;
}

type GetToken = (() => Promise<string | null>) | undefined;

async function post(getToken: GetToken, path: string, body: unknown): Promise<unknown> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  const token = getToken ? await getToken() : null;
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API_ORIGIN}${path}`, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify(body),
  });
  const text = await res.text();
  const json = text ? (JSON.parse(text) as { data?: unknown; error?: { message?: string } }) : {};
  if (!res.ok) throw new Error(json.error?.message ?? "Request failed");
  return json.data;
}

export const memberWrites = {
  tier: (getToken: GetToken, id: string, tier: Tier) =>
    post(getToken, `/v1/command/members/${id}/tier`, { tier }),
  status: (getToken: GetToken, id: string, status: MemberStatus) =>
    post(getToken, `/v1/command/members/${id}/status`, { status }),
  edit: (getToken: GetToken, id: string, fields: MemberEditFields) =>
    post(getToken, `/v1/command/members/${id}/edit`, fields),
};
